/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React, { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [message, setMessage] = useState("");

  return (
    <NotificationContext.Provider
      value={{ isOpen, setIsOpen, isFailed, setIsFailed, message, setMessage }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotification = () => useContext(NotificationContext);
